<template>
  <BackgroundImageComponent></BackgroundImageComponent>
  <div class="position-relative">
    <div
      id="card-wrapper"
      class="d-flex justify-content-center align-items-center"
    >
      <div class="card text-center">
        <div class="card-body">
          <h1 class="card-title">404 - Seite nicht gefunden</h1>
          <p class="card-text">
            Die Seite, die du suchst, existiert nicht oder du hast keine
            Berechtigung.
          </p>
          <router-link to="/" class="btn btn-ruderclub-dark-green"
            >Zur Startseite</router-link
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BackgroundImageComponent from "@/components/Shared/BackgroundImageComponent.vue";

export default {
  components: { BackgroundImageComponent },
};
</script>

<style scoped>
#card-wrapper {
  height: calc(100vh - 80px);
}
.card {
  max-width: 600px;
}
</style>
